<template>
  <div :class="[side, { active: value }]" class="drawer" @click.self="close">
    <div class="drawer__inner">
      <div class="drawer__close" @click="close"/>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    side: { type: String, default: 'right' },
  },
  watch: {
    $route() {
      this.close();
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    toggle() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 99;
  pointer-events: none;
  transition: all 0.5s ease-in-out;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;

  &.left {
    @include mobile {
      padding-right: 20px;
    }

    @include tablet {
      padding-right: 50vw;
    }

    .drawer__inner {
      transform: translateX(-100%);
    }
  }

  &.right {
    @include mobile {
      padding-left: 20px;
    }

    @include tablet {
      padding-left: 50vw;
    }

    .drawer__inner {
      transform: translateX(100%);
    }
  }

  &.active {
    pointer-events: auto;
    opacity: 1;

    .drawer__inner {
      transform: translateX(0);
    }
  }

  &__inner {
    overflow: auto;
    flex-grow: 1;
    max-height: 100vh;
    overflow: auto;
    background: #fff;
    transition: all 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
  }

  &__close {
    @include closeButton;
    position: absolute;
    top: 15px;
    right: 15px;
  }
}
</style>
